<template>
  <v-layout row>
    <v-flex
      xs12
      sm6
      offset-sm3>
      <v-card>
        <v-toolbar
          color="secondary"
          flat
          dark>
          <v-toolbar-side-icon><v-icon>fas fa-user-circle</v-icon></v-toolbar-side-icon>

          <v-toolbar-title>Konto verwalten</v-toolbar-title>
        </v-toolbar>
       
        <v-subheader
          class="title">
          Mein Konto löschen
        </v-subheader>
        
        <v-divider></v-divider>
        <v-card-text>
          Falls du glaubst, dass du deine WeVent-Account nicht wieder benutzen und dein Konto löschen möchtest, können wir das schon machen. Du kannst dann dein Konto jedoch nicht wieder aktivieren und auch keine der von dir hinzugefügten Informationen oder Inhalte wieder aufrufen. Wenn du dein Konto immer noch löschen willst, klicke auf "Mein Konto löschen"
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            flat
            class="red--text" 
            @click.stop="deleteAcc = true">
            Mein Konto Löschen
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog

        v-model="deleteAcc"
        max-width="500">
        <v-card
          dark
          class="text-xs-center">
          <v-card-text class="display-1">
            Das ist dann wohl der Abschied!
          </v-card-text>

          <v-card-text>
            <p>
              Dies ist deine letzte Chance, dich umzuentscheiden!
            </p>
            <p>
              Mit dem klick auf "Konto löschen" werden deine Daten unwiderruflich von WeVent gelöscht und können nicht wiederhergestellt werden.
            </p>
            <p>
              Alle Verbindungen werden getrennt und all deine Freunde werden dich vermissen! 
            </p>
            <p>
              Viel Spaß und alles Gute im echten Leben.
            </p>
            <p class="headline">
              Auf Wiedersehen!
            </p>
          </v-card-text>
          <v-card-text v-if="error">
            <app-alert 
              :text="error.message" 
              @dismissed="onDismissed"></app-alert>
          </v-card-text>
          <form @submit.prevent="deleteAccountButton">
            <v-card-actions>
              <v-text-field
                v-model="passwordDelete"
                color="secondary"
                prepend-inner-icon="fas fa-unlock"
                :type="showPwDelete ? 'text' : 'password'"
                :append-icon="showPwDelete ? 'fas fa-eye' : 'fas fa-eye-slash'"
                label="Password bestätigen"
                :error-messages="passwordDeleteErrors"
              
                box
              
                @click:append="showPwDelete = !showPwDelete"
                @change="$v.passwordDelete.$touch()"
                @blur="$v.passwordDelete.$touch()">
              </v-text-field>
            </v-card-actions>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                flat
                @click="cancelDeleteAccount">
                Abbrechen
              </v-btn>

              <v-btn
                :loading="this.$store.getters.loading"
                
                color="red"
                type="submit">
                Konto löschen
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
      
      <!-- <v-flex 
        v-if="deleteAcc"
        xs12 
        md6
        offset-md3>
        <v-text-field
          v-model="password"
          label="Solo"
          placeholder="Confirm Password"
          solo></v-text-field>
        <v-btn 
          class="red--text" 
          @click="deleteAccount">
          Konto Löschen
        </v-btn>
      </v-flex> -->
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import { required, minLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      deleteAcc: false,

      showPwDelete: false,
      passwordDelete: ''
    }
  },
  validations: {
    passwordDelete: {
      required,
      minLength: minLength(6),
    },
  },
  computed: {
    ...mapGetters({
      error: 'error',
    }),
    passwordDeleteErrors() {
      const errors = []
      if (!this.$v.passwordDelete.$dirty) return errors
      !this.$v.passwordDelete.minLength && errors.push('Password must have at least ' + this.$v.passwordDelete.$params.minLength.min + ' letters.')
      !this.$v.passwordDelete.required && errors.push('Password is required.')
      return errors
    },
  },
  methods: {
    // disableAccount() {
    //   this.$store.dispatch('disableAccount')
    // },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    deleteAccountButton () {
      if (this.$v.passwordDelete.$invalid) {
        this.$v.passwordDelete.$touch()
      } else {
        this.$store.dispatch('deleteAccount', this.passwordDelete)
      }
    },
    cancelDeleteAccount() {
      this.$v.passwordDelete.$reset()
      this.deleteAcc = false
    }
    
   
  }
}
</script>
